import InlineText from 'components/elements/texts/InlineText'
import React from 'react'
import styled from 'styled-components'

/**
 * 必須マーク
 */
const Required: React.FC<RequiredProps> = (props) => {
  return <StyledRequired {...props}>必須</StyledRequired>
}

export type RequiredProps = {
  marginLeft?: string
}

const StyledRequired = styled(InlineText)<{
  marginLeft?: string
}>`
  margin-bottom: 1px;
  margin-left: ${(props): string =>
    props.marginLeft ? props.marginLeft : '16px'};
  padding: 2px 5px 1px;
  color: var(--color-text-for-main-background);
  font-size: 10px;
  background: var(--color-error);
  border-radius: 2px;
`

export default Required
